import React from 'react';
import './App.css';
import Addtask from './Todo/Components/Addtask';
import Tasks from './Todo/Components/Tasks';


function App() {

  
  return (
   <div className='App'>
     <Addtask/>
     <Tasks/>
   </div>
  );
}

export default App;
